module.exports = __webpack_public_path__ + "static/media/smilefish_montecarlo.a8b17960.png";